<template lang="html">
  <div class="input-group">
    <div class="input-group-prepend">
      <span class="input-group-text border-right-0" style="background-color:transparent;"><i :style="{'color': icon.color}" :class="icon.family"></i></span>
    </div>
    <input
      :class="[customClass, {'is-invalid': errorMessage }, 'border-left-0']"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)" />
  </div>
</template>

<script>
export default {
  props: {
    value: { default: '' }, // can be different types of values
    type: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    customClass: { type: String, default: 'form-control' },
    icon: { type: Object },
    errorMessage: {
      default: null
    }
  }
}
</script>

<style lang="scss">
</style>
